// Фильтры истории в тулбаре: автор, период (пресеты и даты), тип объекта и поле, текст; чипы Mine и Deleted.
// Состояние — экрана, не хранится.
import { useEffect, useState } from 'react';
import { SegmentedControl } from '@core/ui/SegmentedControl';
import { TogglePill } from '@core/ui/TogglePill';
import { EntitySelect } from '@core/ui/EntitySelect';
import { addDays, today, type ISODate } from '@core/dates';
import { control } from '@core/ui/form';
import { DateButton } from '../roadmap/shared/RangeControls';
import { FIELD_LABEL, TABLE_FIELDS, TABLE_LABEL } from './labels';
import { periodRange, type HistoryFilter, type Period } from './useHistory';

const dayOf = (iso: string | null | undefined): ISODate | null => (iso ? iso.slice(0, 10) : null);

type Props = { value: HistoryFilter; onChange: (f: HistoryFilter) => void; me: string | null; actors: { id: string; name: string; color: string; avatar: string | null }[] };

const sel = control;

export function HistoryFilters({ value, onChange, me, actors }: Props) {
  const [q, setQ] = useState(value.q ?? '');
  useEffect(() => { const t = setTimeout(() => { if ((value.q ?? '') !== q) onChange({ ...value, q: q || null }); }, 300); return () => clearTimeout(t); }, [q, value, onChange]);
  const period: Period | null = !value.from && !value.to ? 'all' : (['today', 'week', 'month'] as Period[]).find((p) => { const r = periodRange(p); return r.from === value.from && r.to === value.to; }) ?? null;
  const fields = value.table ? TABLE_FIELDS[value.table] ?? [] : [];
  return (
    <>
      <EntitySelect label="Author" size="sm" className="w-44" value={value.actor ?? null} empty="Anyone" placeholder="Anyone"
        options={actors.map((a) => ({ id: a.id, name: a.name, color: a.color, avatar: a.avatar, person: true }))} onChange={(actor) => onChange({ ...value, actor })} />
      <SegmentedControl role="group" label="Period" value={period} items={[{ key: 'today', label: 'Today' }, { key: 'week', label: 'This week' }, { key: 'month', label: '30 days' }, { key: 'all', label: 'All' }]}
        onChange={(p) => onChange({ ...value, ...periodRange(p) })} />
      {period !== 'all' && <>
        <DateButton value={dayOf(value.from) ?? addDays(today(), -30)} label="From" onChange={(d) => onChange({ ...value, from: `${d}T00:00:00` })} />
        <span className="text-gray-500">–</span>
        <DateButton value={dayOf(value.to) ? addDays(dayOf(value.to)!, -1) : today()} label="To" onChange={(d) => onChange({ ...value, to: `${addDays(d, 1)}T00:00:00` })} />
      </>}
      <select className={sel} value={value.table ?? ''} aria-label="Object type" onChange={(e) => onChange({ ...value, table: e.target.value || null, field: null })}>
        <option value="">Any object</option>
        {Object.entries(TABLE_LABEL).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
      {fields.length > 0 && (
        <select className={sel} value={value.field ?? ''} aria-label="Field" onChange={(e) => onChange({ ...value, field: e.target.value || null })}>
          <option value="">Any field</option>
          {fields.map((f) => <option key={f} value={f}>{FIELD_LABEL[f] ?? f}</option>)}
        </select>
      )}
      <input type="search" className={`${sel} w-48`} placeholder="Search names and notes…" aria-label="Search history" value={q} onChange={(e) => setQ(e.target.value)} />
      <TogglePill on={!!me && value.actor === me} label="Mine" data={{ 'data-history-mine': '' }} onClick={() => onChange({ ...value, actor: value.actor === me ? null : me })} />
      <TogglePill on={value.kind === 'delete'} label="Deleted" data={{ 'data-history-deleted': '' }} onClick={() => onChange({ ...value, kind: value.kind === 'delete' ? null : 'delete' })} />
    </>
  );
}
